import Component from '../abstracts/Component';

export default class ConfirmEnableComponent extends Component {

  get SELECTORS() {
    return {
      main: '.jsConfirmStepBtn',
    };
  }

  constructor() {
    super();
  }
  
  initEnableToggler(){
    let btn = document.querySelector(this.SELECTORS.main);
    this.$on(this.$customEvents.CHANGE_RETURN_STEPS.enableConfirm,()=>{
      btn.disabled = false;
    });
    this.$on(this.$customEvents.CHANGE_RETURN_STEPS.disabledConfirm,()=>{
      btn.disabled = true;
    });
  }
  
  render() {
    
    if(document.querySelector(this.SELECTORS.main)){
      this.initEnableToggler();
    }

    let myName = this.constructor.name;
    console.log(`[${myName}] Rendering..`);
  }
}
